import { processEnv } from '~/utils/env'
import { genUUID } from '~/utils/generate'
import { hasWindow } from '~/utils/helpers'

const measurementId = processEnv.GA4_MEASUREMENT_ID
const apiSecret = processEnv.GA4_ID

export const sendGA4Event = async (eventName: 'click_accept' | 'click_reject' | 'click_settings') => {
  if (hasWindow() && measurementId && apiSecret) {
    fetch(`https://www.google-analytics.com/mp/collect?measurement_id=${measurementId}&api_secret=${apiSecret}`, {
      method: 'POST',
      body: JSON.stringify({
        client_id: genUUID(window.crypto),
        events: [
          {
            name: `{{${eventName}}}`,
          },
        ],
      }),
    })
  }
}
